module.exports = __webpack_public_path__ + "static/media/Ampharos_gaussian2.098118b2.png";